import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useAuth } from 'contexts/AuthContext';

export default function SuperadminGate({ children }) {
  const { user, loading, logout } = useAuth();
  const location = useLocation();
  const rejecting = useRef(false);

  useEffect(() => {
    if (loading || !user || ['superadmin', 'platform_sales'].includes(user.role) || rejecting.current) return;
    rejecting.current = true;
    logout();
  }, [loading, user, logout]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!['superadmin', 'platform_sales'].includes(user.role)) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography>This console is only for platform operators.</Typography>
      </Box>
    );
  }

  return children;
}
